import ValidationError from 'domain/errors/ValidationError';

import validateRecipe from 'domain/recipe/usecases/validate_recipe';

import RecipeDataModelFactory from 'services/factory/RecipeDataModelFactory';
import RecipesService from 'services/recipes';

const createRecipe = async (recipe, idempotencyToken, userModel) => {
  if (!recipe) throw new ValidationError('recipe cannot be empty');

  if (!idempotencyToken) throw new Error('idempotencyToken cannot be empty');

  if (!userModel) throw new Error('userModel cannot be empty');

  const error = validateRecipe(recipe);
  if (error) throw new ValidationError('recipe is invalid');

  const content = {
    ...recipe,
    additionalData: {
      ...recipe.additionalData,
    },
  };

  const { coverPhotoURL } = content.additionalData;
  content.additionalData.coverPhotoURL = '';

  const recipeDataModel = RecipeDataModelFactory(
    content,
    userModel,
    idempotencyToken
  );

  const recipeModel = await RecipesService.create(recipeDataModel);

  if (coverPhotoURL) {
    const downloadURL = await RecipesService.uploadCoverPhoto(
      recipeModel.id,
      coverPhotoURL
    );

    await RecipesService.edit(recipeModel.id, {
      ...recipeDataModel.content,
      additionalData: {
        ...recipeDataModel.content.additionalData,
        coverPhotoURL: downloadURL,
      },
    });
  }

  return recipeModel;
};

export default createRecipe;
